/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-nested-ternary */
/* eslint-disable object-shorthand */
import { LoadingButton } from "@mui/lab";
import { Button, IconButton, styled, Typography } from "@mui/material";
import React from "react";
import Iconify from "./Iconify";
import LucideIcon from "./LucideIcon";

const CustomButton = ({
  backgroundColor,
  color,
  buttonText,
  heroBtn,
  guideBtn,
  getStartedBtn,
  type,
  startIcon,
  icon='ChevronLeft',
  loading,
  ...buttonProps
}) => {
  const CustomButton = styled(buttonText == null ? IconButton : LoadingButton)(({ theme }) => (type === 'primaire' ? {
    textTransform: 'initial',
    border: '2px solid transparent',
    color: 'white',
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop:10,
    paddingBottom:10,
    backgroundColor: '#5E17EB',
    borderRadius: '12px',
    boxShadow: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#A47CF4',
      color: 'white',
      borderColor: '#A47CF4',
    },

  } : type === 'secondaire' ? {
    textTransform: 'initial',
    border: '1px solid gainsboro',
    color: '#202025',
    whiteSpace: 'nowrap',
    backgroundColor: 'transparent',
    borderRadius: '12px',
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop:10,
    paddingBottom:10,
    '&:hover': {
      backgroundColor: '#f2f2f2',
      color: '#202025',
      border: '1px solid gainsboro',
    },

  } : type === 'tertiaire' ? {
    whiteSpace: 'nowrap',
    textTransform: 'initial',
    border: '1.5px solid transparent',
    color: '#5E17EB',
    backgroundColor: 'transparent',
    borderRadius: '12px',
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop:10,
    paddingBottom:10,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#5E17EB',
      borderColor: 'transparent',
    }

  } : type === 'back' ? {
    whiteSpace: 'nowrap',
    textTransform: 'initial',
    color: '#86868f',
    backgroundColor: 'transparent',
    borderRadius: '12px',
    paddingTop:10,
    paddingBottom:10,
    borderColor: '#A9A8B3',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#202025',
      border: 'none',
    },

  } : {
    textTransform: 'initial',
    whiteSpace: 'nowrap',
    border: '2px solid transparent',
    color: 'white',
    backgroundColor: '#5E17EB',
    borderRadius: '12px',
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop:10,
    paddingBottom:10,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'white',
      color: '#5E17EB',
      borderColor: '#5E17EB',
    },

  }));

  return <CustomButton {...buttonProps}  startIcon={ type === 'back' ? <LucideIcon name='ArrowLeft' /> : startIcon} loading={loading} loadingPosition="end">
    {buttonText == null ? <LucideIcon name={icon} /> : <Typography fontSize={16}>{buttonText}</Typography>}
  </CustomButton>;
};

export default CustomButton;